export const INTEGRATIONS_WRITE_PERMISSION = {
  resource: "integrations",
  action: "write"
} as const
